var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('short-text-filter', {
    attrs: {
      "id": _vm.filterData.key + '-filter',
      "label": _vm.filterData.label,
      "update-method": _vm.updateValue,
      "use-json-api-filter-manager": false
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }